import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, Box, Paper, Button, CircularProgress } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AdminUserForm from '../components/Admin/AdminUserForm';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

function AddAdminUserPage() {
  const navigate = useNavigate();
  const { isFullAdmin } = useAuth(); // Ensure only full admins access this
  const [availableApps, setAvailableApps] = useState([]);
  const [loadingApps, setLoadingApps] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    // Redirect if not a full admin
    if (!isFullAdmin()) {
      navigate('/select-app');
      return;
    }

    // Fetch all available apps for selection
    const fetchAllApps = async () => {
      try {
        const response = await axios.get('/api/apps'); // Full admins get all apps
        setAvailableApps(response.data);
      } catch (err) {
        console.error('Failed to fetch apps for admin form:', err);
        setError('Could not load available applications.');
      } finally {
        setLoadingApps(false);
      }
    };

    fetchAllApps();
  }, [isFullAdmin, navigate]);

  const handleCreateUser = async (payload) => {
    try {
      await axios.post('/api/admins', payload);
      navigate('/select-app'); // Go back to app selection after creation
      // Consider adding a success message via state or context
    } catch (err) {
      console.error('Create admin user error:', err);
      // Let the form display the error
      throw new Error(err.response?.data?.message || 'Failed to create user');
    }
  };

  if (!isFullAdmin()) {
    // Should have been redirected, but good practice
    return null; 
  }
  
  return (
    <Container maxWidth="md">
      <Box sx={{ my: 4 }}>
        <Button 
          startIcon={<ArrowBackIcon />} 
          onClick={() => navigate('/select-app')} // Go back to app selection
          sx={{ mb: 2 }}
        >
          Back to App Selection
        </Button>
        <Paper sx={{ p: 3 }}>
          <Typography variant="h5" component="h1" gutterBottom>
            Add New Admin User
          </Typography>
          {loadingApps ? (
            <CircularProgress />
          ) : error ? (
            <Typography color="error">{error}</Typography>
          ) : (
            <AdminUserForm 
              onSubmit={handleCreateUser} 
              isEditing={false} 
              availableApps={availableApps}
            />
          )}
        </Paper>
      </Box>
    </Container>
  );
}

export default AddAdminUserPage; 